// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"t4-z","colorTextValue":"u4-z","swatches":"v4-z","collapseLink":"w4-z","isCollapsed":"x4-z","dropdown":"y4-z","disabled":"z4-z"};